import ButtonSlideMenu from "./ButtonSlideMenu";
import { POST_TITLE } from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { useContentModals } from "../../contexts/contentModalsContext";
import { Share2 } from "lucide-react";

const ButtonOpenCalendar = () => {
  const { t } = useTranslationApp();
  const { openCalendar } = useContentModals();

  return (
    <ButtonSlideMenu
      id="button-open-calendar"
      startIcon={<Share2 className="w-5 h-5" />}
      onClick={() => openCalendar()}
    >
      {t(POST_TITLE)}
    </ButtonSlideMenu>
  );
};

export default ButtonOpenCalendar;
